import { inject, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

function registerIcons(matIcon: MatIconRegistry, sanitizer: DomSanitizer): void {
  matIcon.addSvgIconLiteral(
    'mdi-barn',
    sanitizer.bypassSecurityTrustHtml(
      // eslint-disable-next-line max-len
      `<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path d="M12,3L3,8.2V21H9L11.9,18L15,21H21V8.2L12,3M7.9,20V14L10.9,17L7.9,20M8.9,13H14.9L11.9,16L8.9,13M15.9,20L12.9,17L15.9,14V20M15,11H8.8V9H15V11Z" /></svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'mdi-inbox-arrow-down',
    sanitizer.bypassSecurityTrustHtml(
      // eslint-disable-next-line max-len
      `<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path d="M16,10H14V7H10V10H8L12,14M19,15H15A3,3 0 0,1 12,18A3,3 0 0,1 9,15H5V5H19M19,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" /></svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'mdi-inbox-arrow-up',
    sanitizer.bypassSecurityTrustHtml(
      // eslint-disable-next-line max-len
      `<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path d="M14,14H10V11H8L12,7L16,11H14V14M16,11M5,15V5H19V15H15A3,3 0 0,1 12,18A3,3 0 0,1 9,15H5M19,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3" /></svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'mdi-walk',
    sanitizer.bypassSecurityTrustHtml(
      // eslint-disable-next-line max-len
      `<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path d="M14.12 10H19V8.2h-3.62l-2-3.33c-.3-.5-.84-.84-1.46-.84c-.18 0-.34.03-.5.08L6 5.8V11h1.8V7.33l2.11-.66L6 22h1.8l2.87-8.11L13 17v5h1.8v-6.41l-2.49-4.54l.73-2.87M14 3.8c1 0 1.8-.8 1.8-1.8S15 .2 14 .2S12.2 1 12.2 2S13 3.8 14 3.8z" fill="currentColor"/></svg>`,
    ),
  );
}

export const provideIconInitializer = () =>
  provideAppInitializer(() => {
    const matIcon = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);
    registerIcons(matIcon, sanitizer);
  });
